const env = process.env.NODE_ENV || "development";

const apiEnvironment = {
  // DOMAIN SERVER MỚI
  development: {
    api: "https://tphoabinh-api.cgis.asia/",
    media_url: "https://tphoabinh-api.cgis.asia/",
    domainAdminSide: "http://localhost:3000",
    domainUserSide: "http://localhost:3000",
    domainName: "",
    workSpace: "tphoabinh",
    wmsBaseLink: "https://geo3.cgis.asia/geoserver/tphoabinh/wms",
    datastore: 'tphoabinh',
    gwcUrl: 'https://geo3.cgis.asia/geoserver/gwc/service/wms/'
  },
    production: {
      api: "https://tphoabinh-api.cgis.asia/",
      media_url: "https://tphoabinh-api.cgis.asia/",
      domainAdminSide: "https://admin.tphoabinh.cgis.asia",
      domainUserSide: "https://tphoabinh.cgis.asia",
      domainName: "tphoabinh.cgis.asia",
      workSpace: "tphoabinh",
      wmsBaseLink: "https://geo3.cgis.asia/geoserver/tphoabinh/wms",
      datastore: 'tphoabinh',
      gwcUrl: 'https://geo3.cgis.asia/geoserver/gwc/service/wms/'
  }

};

module.exports = apiEnvironment[env];
